define('entities/webshop/quotations',[
  'app',
  'settings',
  'underscore'
], function (
  App,
  Settings,
  _
) {
  'use strict';

  // Quotations generated on the webshop product pages (PHP webshop api/quotations/**,
  // through the backend webshop proxy). Read only.

  var call = function (path, params) {
    var defer = $.Deferred();

    $.ajax({
      type: 'GET',
      url: Settings.url('compuzz2', 'webshop/quotations/' + path, params || {}),
      success: function (result) {
        defer.resolve(result);
      },
      error: function (jqXHR) {
        var message = '';
        if (jqXHR.responseJSON && jqXHR.responseJSON.message)
          message = jqXHR.responseJSON.message;
        defer.reject(message || _.i18n('webshop.errors.unknown', null, 'Unknown error'));
      }
    });

    return defer.promise();
  };

  return {
    // params: query, from, to (yyyy-mm-dd), domain, first, pageSize → {total, items, domains}
    search: function (params) {
      return call('search', params);
    },
    get: function (id) {
      return call('get', {id: id});
    },

    formatPrice: function (value, currency) {
      if (value === null || value === undefined)
        return '';
      return Number(value).toLocaleString('fr-BE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) +
        ' ' + (currency || 'EUR');
    },

    formatDate: function (value) {
      if (!value)
        return '';
      return new Date(value).toLocaleString('fr-BE', {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
      });
    },

    customerLabel: function (customer) {
      if (!customer)
        return '';
      return _.compact([customer.company, customer.name, customer.email]).join(' · ');
    }
  };
});

